import { HOURS, CONTACT, IMAGES } from "@/lib/menuData";
import { MapPin, Clock, Navigation } from "lucide-react";

export const HoursLocation = () => {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.address)}`;
  return (
    <section id="hours" data-testid="hours-section" className="border-b-2 border-[color:var(--brand-ink)] bg-[color:var(--brand-bg)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="grid lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-7">
            <p className="font-bold text-sm uppercase tracking-[0.2em] text-[color:var(--brand-red)]">Hours & Location</p>
            <h2 className="font-display text-5xl sm:text-6xl uppercase mt-2">Come Hungry</h2>

            <div data-testid="hours-card" className="mt-8 border-2 border-[color:var(--brand-ink)] bg-white shadow-brutal">
              <div className="flex items-center gap-3 bg-[color:var(--brand-ink)] text-white px-5 py-3">
                <Clock size={18} strokeWidth={2.75} />
                <h3 className="font-display text-xl uppercase">Daily Hours</h3>
              </div>
              <ul className="divide-y-2 divide-[color:var(--brand-ink)]">
                {HOURS.map((h) => (
                  <li
                    key={h.day}
                    data-testid={`hours-${h.day.toLowerCase()}`}
                    className={`flex items-center justify-between px-5 py-4 ${h.closed ? 'bg-[color:var(--brand-red)] text-white' : ''}`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="font-display text-xl uppercase">{h.day}</span>
                      {h.weekend && (
                        <span className="text-[10px] font-bold uppercase tracking-wider bg-[color:var(--brand-yellow)] text-[color:var(--brand-ink)] border border-[color:var(--brand-ink)] px-1.5 py-0.5">
                          Tamales Day
                        </span>
                      )}
                    </div>
                    <span className={`font-bold ${h.closed ? 'uppercase tracking-wider' : ''}`}>{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <aside id="visit" data-testid="visit-card" className="lg:col-span-5">
            <div className="border-2 border-[color:var(--brand-ink)] bg-white shadow-brutal overflow-hidden">
              <img src={IMAGES.storefront} alt="El Loco Taco storefront" className="w-full h-56 object-cover border-b-2 border-[color:var(--brand-ink)]" />
              <div className="p-6">
                <div className="flex items-start gap-3">
                  <MapPin size={22} strokeWidth={2.75} className="text-[color:var(--brand-red)] mt-0.5" />
                  <div>
                    <h3 className="font-display text-2xl uppercase leading-none">Find Us</h3>
                    <p className="mt-2 font-semibold">{CONTACT.address}</p>
                  </div>
                </div>
                <a
                  href={mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="directions-btn"
                  className="btn-brutal mt-5 w-full inline-flex items-center justify-center gap-2 bg-[color:var(--brand-red)] text-white font-bold uppercase px-4 py-3 border-2 border-[color:var(--brand-ink)] shadow-brutal-sm"
                >
                  <Navigation size={16} strokeWidth={2.75} /> Get Directions
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default HoursLocation;
